    import React, { useState, useEffect, useRef, useId } from 'react';
    import { connect } from 'react-redux';
    import './AST.css';
    import { PrimaryButton, DefaultButton, IconButton, TooltipHost } from '@fluentui/react';
    import { Dialog, DialogType, DialogFooter } from '@fluentui/react/lib/Dialog';
    import SingleLineField from '../../Forms/SingleLineField/SingleLineField';
    import { runTestPatternQuery, runBreakpointsQuery } from './ASTQueries';
    import TranslateTag from '../../../Utils/Local/TranslateTag';
    import AlertList from '../../General/AlertList/AlertList';
    import Post from '../../../Data/Post';

    const testPatternConfig =
    {
        Id: 'testpattern', Type: 'dropdown', Label: '', Required: false, Placeholder: "", value: "", noTab: true,
        Options: []
    };

    const testPatternFullListConfig =
    {
        Id: 'testpatternfulllist', Type: 'dropdown', Label: '', Required: false, Placeholder: "", value: "", noTab: true,
        Options: []
    };

    const BLFieldConfig =
    {
        Id: 'bl', Type: 'combobox', Label: '', Required: false, Placeholder: "", value: "",
        Options: []
    };

    const ESBLFieldConfig =
    {
        Id: 'esbl', Type: 'combobox', Label: '', Required: false, Placeholder: "", value: "",
        Options: []
    };

    const CarbapenemaseFieldConfig =
    {
        Id: 'carbapenemase', Type: 'combobox', Label: '', Required: false, Placeholder: "", value: "",
        Options: []
    };

    const ASTCommentOneConfig =
    {
        Id: 'astcommentone', Type: 'combobox', Label: '', Required: false, value: "", Options: []
    };

    const ASTCommentTwoConfig =
    {
        Id: 'astcommenttwo', Type: 'combobox', Label: '', Required: false, value: "", Options: []
    };

    const ASTAdditionalNotesConfig =
    {
        Id: 'astadditionalnotes', Type: 'multiline', Label: '', Required: false, value: ""
    };

    const deleteBlankRowsConfig =
    {
        Id: 'deleteblankrows', Type: 'toggle', Label: '', value: 'Yes'
    };

    const MICValueMappingsForGuidelines =
    [
        { Geometric: 512, EUCAST: 512, CLSI: 512 },
        { Geometric: 256, EUCAST: 256, CLSI: 256 },
        { Geometric: 128, EUCAST: 128, CLSI: 128 },
        { Geometric: 64, EUCAST: 64, CLSI: 64 },
        { Geometric: 32, EUCAST: 32, CLSI: 32 },
        { Geometric: 16, EUCAST: 16, CLSI: 16 },
        { Geometric: 8, EUCAST: 8, CLSI: 8 },
        { Geometric: 4, EUCAST: 4, CLSI: 4 },
        { Geometric: 2, EUCAST: 2, CLSI: 2 },
        { Geometric: 1, EUCAST: 1, CLSI: 1 },
        { Geometric: 0.5, EUCAST: 0.5, CLSI: 0.5 },
        { Geometric: 0.25, EUCAST: 0.25, CLSI: 0.25 },
        { Geometric: 0.125, EUCAST: 0.125, CLSI: 0.12 },
        { Geometric: 0.0625, EUCAST: 0.06, CLSI: 0.06 },
        { Geometric: 0.03125, EUCAST: 0.03, CLSI: 0.03 },
        { Geometric: 0.015625, EUCAST: 0.016, CLSI: 0.016 },
        { Geometric: 0.0078125, EUCAST: 0.008, CLSI: 0.008 },
        { Geometric: 0.00390625, EUCAST: 0.004, CLSI: 0.004 },
        { Geometric: 0.001953125, EUCAST: 0.002, CLSI: 0.002 },
        { Geometric: 0.0009765625, EUCAST: 0.001, CLSI: 0.001 }
    ];

    const AST = (props) => {

    const modalPropsStyles = { main: { maxWidth: 450 } };
    const dialogContentProps = {
        type: DialogType.normal,
        title: TranslateTag("@GenRem@", props.language),
        subText: TranslateTag("@GenRemA@", props.language)
    };
    const ASTRowRemovalConfirmation = props.preferences !== undefined && props.preferences.ASTRowRemovalConfirmation === "Yes";
    const calloutProps = { gapSpace: 10 };
    const categoryColours = [ 'black', 'red', 'blue', 'green' ];

    const [cultureId, setCultureId] = useState(0);
    const [testPattern, setTestPattern] = useState(null);
    const [testPatternFullList, setTestPatternFullList] = useState(null);
    const [BLField, setBLField] = useState(null);
    const [ESBLField, setESBLField] = useState(null);
    const [CarbapenemaseField, setCarbapenemaseField] = useState(null);
    const [deleteBlankRows, setDeleteBlankRows] = useState(null);
    const [ASTCommentOne, setASTCommentOne] = useState(null);
    const [ASTCommentTwo, setASTCommentTwo] = useState(null);
    const [ASTAdditionalNotes, setASTAdditionalNotes] = useState(null);
    const [diskManualAntibioticsForm, setDiskManualAntibioticsForm] = useState([]);
    const [diskManualRowCounter, setDiskManualRowCounter] = useState(1);
    const [stripManualAntibioticsForm, setStripManualAntibioticsForm] = useState([]);
    const [stripManualRowCounter, setStripManualRowCounter] = useState(1);
    const [showDialog, _setShowDialog] = useState(false);
    const [rowToDelete, setRowToDelete] = useState({ special: false, type: "", index: 0 });
    const [alertMessages, setAlertMessages] = useState([]);

    const showDialogRef = useRef(showDialog);

    // Globals initialised on every render.
    var changedTestPattern = null;
    var changedTestPatternFullList = null;
    var changedBLField = null;
    var changedESBLField = null;
    var changedCarbapenemaseField = null;
    var changedDeleteBlankRows = null;
    var changedASTCommentOne = null;
    var changedASTCommentTwo = null;
    var changedASTAdditionalNotes = null;
    var changedDiskManualAntibioticsForm = null;
    var changedDiskManualRowCounter = null;
    var changedStripManualAntibioticsForm = null;
    var changedStripManualRowCounter = null;


    useEffect(() => {
        initialSetUp();
        populateWithRetrievedData();
        updateSaveableData();
        setTimeout(() => {
            document.getElementById("diskmanumeas1").focus();
        }, 10);
    }, [])

    const initialSetUp = () => {
//        if (testPatternFullListConfig.Options.length === 0) {
        testPatternFullListConfig.Options = [];
        let index = props.lists.findIndex(l => l.Name === 'testpatternnameslist');
        if (index !== -1) {
            for (var option of props.lists[index].Options) {
                let mappedOption = { key: option.Key, text: option.Text };
                testPatternFullListConfig.Options.push(mappedOption);
            }
        }
//      }
        if (ESBLFieldConfig.Options.length === 0) {
            let index = props.lists.findIndex(l => l.Name === 'esbl');
            if (index !== -1) {
                for (var option of props.lists[index].Options) {
                    let mappedOption = { key: option.Key, text: option.Text };
                    ESBLFieldConfig.Options.push(mappedOption);
                }
            }
        }
        if (BLFieldConfig.Options.length === 0) {

            let index = props.lists.findIndex(l => l.Name === 'betalactamase');
            if (index !== -1) {
                for (var option of props.lists[index].Options) {
                    let mappedOption = { key: option.Key, text: option.Text };
                    BLFieldConfig.Options.push(mappedOption);
                }
            }
        }
        if (CarbapenemaseFieldConfig.Options.length === 0) {
            let index = props.lists.findIndex(l => l.Name === 'carbapenemase');
            if (index !== -1) {
                for (var option of props.lists[index].Options) {
                    let mappedOption = { key: option.Key, text: option.Text };
                    CarbapenemaseFieldConfig.Options.push(mappedOption);
                }
            }
        }
        if (ASTCommentOneConfig.Options.length === 0) {
            let index = props.lists.findIndex(l => l.Name === 'cannedcomments');
            if (index !== -1) {
                for (var option of props.lists[index].Options) {   
                    if(option.ParentKey === "1233"){                
                    let mappedOption = { key: option.Key, text: option.Text };
                    ASTCommentOneConfig.Options.push(mappedOption);
                    }
                }
            }
        }
        if (ASTCommentTwoConfig.Options.length === 0) {
            let index = props.lists.findIndex(l => l.Name === 'cannedcomments');
            if (index !== -1) {
                for (var option of props.lists[index].Options) {
                    if(option.ParentKey === "1233"){
                    let mappedOption = { key: option.Key, text: option.Text };
                    ASTCommentTwoConfig.Options.push(mappedOption);
                    }
                }
            }
        }

        BLFieldConfig.Label = TranslateTag("@TesBetA@", props.language);
        ESBLFieldConfig.Label = TranslateTag("@SpeEsb@", props.language);
        CarbapenemaseFieldConfig.Label = TranslateTag("@TesCarC@", props.language);
        BLFieldConfig.Placeholder = TranslateTag("@AstPre@", props.language);
        ESBLFieldConfig.Placeholder = TranslateTag("@AstPre@", props.language);
        CarbapenemaseFieldConfig.Placeholder = TranslateTag("@AstPre@", props.language);
        deleteBlankRowsConfig.Label = TranslateTag("@AstRem@", props.language);
        ASTCommentOneConfig.Label = TranslateTag("@AstCom3@", props.language);
        ASTCommentTwoConfig.Label = TranslateTag("@AstCom4@", props.language);
        ASTAdditionalNotesConfig.Label = TranslateTag("@GenAdd@", props.language);

        setTestPatternFullList(testPatternFullListConfig);
        setBLField(BLFieldConfig);
        setESBLField(ESBLFieldConfig);
        setCarbapenemaseField(CarbapenemaseFieldConfig);
        setDeleteBlankRows(deleteBlankRowsConfig);
        setASTCommentOne(ASTCommentOneConfig);
        setASTCommentTwo(ASTCommentTwoConfig);
        setASTAdditionalNotes(ASTAdditionalNotesConfig);

        changedTestPatternFullList = testPatternFullListConfig;
        changedBLField = BLFieldConfig;
        changedESBLField = ESBLFieldConfig;
        changedCarbapenemaseField = CarbapenemaseFieldConfig;
        changedTestPattern = testPatternConfig;
        changedDeleteBlankRows = deleteBlankRowsConfig;
        changedASTCommentOne = ASTCommentOneConfig;
        changedASTCommentTwo = ASTCommentTwoConfig;
        changedASTAdditionalNotes = ASTAdditionalNotesConfig;
        changedDiskManualAntibioticsForm = [];
        changedStripManualAntibioticsForm = [];

        // Start with an empty line for each test-method.
        addAntibioticClickHandler('Disk');
        addAntibioticClickHandler('Strip');
    };

    const populateWithRetrievedData = () => {

        // We should always get data back at the culture level, so this is defensive.
        if (props.data === undefined || props.data === null) {
            return;
        }

        let ASTData = JSON.parse(props.data[0].Value);

        // Save cultureId for in-form queries.
        setCultureId(ASTData.CultureId);

        // Get alerts.
        resetAlerts(ASTData.CultureId);

        // Populate test-pattern drop-down with valid test-pattern options (from the b'end).
        testPatternConfig.Options = [];
        if (ASTData.TestPatternOptions !== null && ASTData.TestPatternOptions !== undefined && ASTData.TestPatternOptions.length > 0) {
            for (var option of ASTData.TestPatternOptions) {
                let mappedOption = { key: option.Id.toString(), text: option.TestPatternName };
                testPatternConfig.Options.push(mappedOption);
           }
        }
        testPatternConfig.Label = TranslateTag("@AstTesB@", props.language);
        testPatternConfig.Placeholder = TranslateTag("@AstTesC@", props.language);
        testPatternFullListConfig.Label = TranslateTag("@AstTesE@", props.language);
        testPatternFullListConfig.Placeholder = TranslateTag("@AstTesF@", props.language);

        // A test-pattern will only be selected (from the b'end) if there are no saved AST results.
        if (ASTData.TestPatternToSelect !== null && ASTData.TestPatternToSelect !== undefined) {
            changedTestPattern.value = ASTData.TestPatternToSelect.Id.toString();
            applyTestPattern(ASTData.TestPatternToSelect.AntibioticGrid);
        } else {
            changedTestPattern.value = "";
        }
        setTestPattern(changedTestPattern);

        // Set up the AST rows as previously saved (in which case a test-pattern will not have been selected).
        let manualDiskRowCount = 0;
        let manualStripRowCount = 0;
        for (var row of ASTData.ASTResults) {
            if (row.ASTResult.TestType === 'Disk' && row.ASTResult.EntryType === 'manual') {
                if (manualDiskRowCount > 0) {
                    addAntibioticClickHandler('Disk');
                }
                changedDiskManualAntibioticsForm[manualDiskRowCount].antibiotic.value = row.ASTResult.Antibiotic;
                changedDiskManualAntibioticsForm[manualDiskRowCount].dosage.value = row.ASTResult.Dosage;
                changedDiskManualAntibioticsForm[manualDiskRowCount].guidelines.value = row.ASTResult.Guidelines;
                changedDiskManualAntibioticsForm[manualDiskRowCount].zoneDiameter.value = row.ASTResult.Measurement == -1 ? "" : row.ASTResult.Measurement;
                changedDiskManualAntibioticsForm[manualDiskRowCount].susceptibility.value = row.ASTResult.Susceptibility;
                changedDiskManualAntibioticsForm[manualDiskRowCount].category.value = row.ASTResult.Category;
                changedDiskManualAntibioticsForm[manualDiskRowCount].includeInReport.value = row.ASTResult.IncludeInReport;
                changedDiskManualAntibioticsForm[manualDiskRowCount].breakpoint = getStandardBreakpoint(row.Breakpoints);
                changedDiskManualAntibioticsForm[manualDiskRowCount].specialBreakpoints = getSpecialBreakpoints(row.Breakpoints);
                restoreSpecialBreakpointRows(changedDiskManualAntibioticsForm[manualDiskRowCount], row.ASTResult.SpecialRows, 'Disk', manualDiskRowCount);
                manualDiskRowCount++;
            }
        }
        if (manualDiskRowCount > 0) {
            setDiskManualAntibioticsForm(changedDiskManualAntibioticsForm);
        }

        for (row of ASTData.ASTResults) {
            if (row.ASTResult.TestType === 'Strip' && row.ASTResult.EntryType === 'manual') {
                if (manualStripRowCount > 0) {
                    addAntibioticClickHandler('Strip');
                }
                changedStripManualAntibioticsForm[manualStripRowCount].antibiotic.value = row.ASTResult.Antibiotic;
                changedStripManualAntibioticsForm[manualStripRowCount].dosage.value = row.ASTResult.Dosage;
                changedStripManualAntibioticsForm[manualStripRowCount].guidelines.value = row.ASTResult.Guidelines;
                changedStripManualAntibioticsForm[manualStripRowCount].MIC.value = row.ASTResult.Measurement == -1 ? "" : row.ASTResult.Measurement;
                changedStripManualAntibioticsForm[manualStripRowCount].susceptibility.value = row.ASTResult.Susceptibility;
                changedStripManualAntibioticsForm[manualStripRowCount].category.value = row.ASTResult.Category;
                changedStripManualAntibioticsForm[manualStripRowCount].includeInReport.value = row.ASTResult.IncludeInReport;
                changedStripManualAntibioticsForm[manualStripRowCount].breakpoint = getStandardBreakpoint(row.Breakpoints);
                changedStripManualAntibioticsForm[manualStripRowCount].specialBreakpoints = getSpecialBreakpoints(row.Breakpoints);
                restoreSpecialBreakpointRows(changedStripManualAntibioticsForm[manualStripRowCount], row.ASTResult.SpecialRows, 'Strip', manualStripRowCount);
                manualStripRowCount++;
            }
        }
        if (manualStripRowCount > 0) {
            setStripManualAntibioticsForm(changedStripManualAntibioticsForm);
        }

        changedBLField.value = ASTData.BL;
        changedESBLField.value = ASTData.ESBL;
        changedCarbapenemaseField.value = ASTData.Carbapenemase;
        changedASTCommentOne.value = ASTData.ASTCommentOne;
        changedASTCommentTwo.value = ASTData.ASTCommentTwo;
        changedASTAdditionalNotes.value = ASTData.ASTAdditionalNotes;
        setBLField(changedBLField);
        setESBLField(changedESBLField);
        setCarbapenemaseField(changedCarbapenemaseField);
        setASTCommentOne(changedASTCommentOne);
        setASTCommentTwo(changedASTCommentTwo);
        setASTAdditionalNotes(changedASTAdditionalNotes);
    }

    const applyTestPattern = (rows) => {

        // Set up the AST rows defined by the test-pattern.
        let manualDiskRowCount = 0;
        let manualStripRowCount = 0;
        for (var row of rows) {
            if (row.TestMethodId === 681) {
                if (manualDiskRowCount > 0) {
                    addAntibioticClickHandler('Disk');
                }
                changedDiskManualAntibioticsForm[manualDiskRowCount].category.value = row.CategoryId.toString();
                changedDiskManualAntibioticsForm[manualDiskRowCount].antibiotic.value = row.AntibioticId.toString();
                changedDiskManualAntibioticsForm[manualDiskRowCount].dosage.value = row.Dosage;
                changedDiskManualAntibioticsForm[manualDiskRowCount].guidelines.value = row.GuidelinesId.toString();
                changedDiskManualAntibioticsForm[manualDiskRowCount].breakpoint = getStandardBreakpoint(row.breakpoints);   // row.breakpoints[0].BreakpointGrid;
                changedDiskManualAntibioticsForm[manualDiskRowCount].specialBreakpoints = getSpecialBreakpoints(row.breakpoints);
                changedDiskManualAntibioticsForm[manualDiskRowCount].includeInReport.value = row.PrintOnReport;
                addSpecialBreakpointRows(changedDiskManualAntibioticsForm[manualDiskRowCount], 'disk', manualDiskRowCount, row.PrintOnReport);
                manualDiskRowCount++;
            } else if (row.TestMethodId === 680) {
                if (manualStripRowCount > 0) {
                    addAntibioticClickHandler('Strip');
                }
                changedStripManualAntibioticsForm[manualStripRowCount].category.value = row.CategoryId.toString();
                changedStripManualAntibioticsForm[manualStripRowCount].antibiotic.value = row.AntibioticId.toString();
                changedStripManualAntibioticsForm[manualStripRowCount].dosage.value = row.Dosage;
                changedStripManualAntibioticsForm[manualStripRowCount].guidelines.value = row.GuidelinesId.toString();
                changedStripManualAntibioticsForm[manualStripRowCount].breakpoint = getStandardBreakpoint(row.breakpoints);   // row.breakpoints[0].BreakpointGrid;
                changedStripManualAntibioticsForm[manualStripRowCount].specialBreakpoints = getSpecialBreakpoints(row.breakpoints);
                changedStripManualAntibioticsForm[manualStripRowCount].includeInReport.value = row.PrintOnReport;
                addSpecialBreakpointRows(changedStripManualAntibioticsForm[manualStripRowCount], 'strip', manualStripRowCount, row.PrintOnReport);
                manualStripRowCount++;
            }
        }
    }

    const getStandardBreakpoint = (breakpoints) => {
        for (var breakpoint of breakpoints) {
            if (breakpoint.SpecialConsiderId === 973) {
                return breakpoint.BreakpointGrid;
            }
        }
        return null;
    }

    const getSpecialBreakpoints = (breakpoints) => {
        var specialBreakpoints = [];
        for (var breakpoint of breakpoints) {
            if (breakpoint.SpecialConsiderId !== 973) {
                specialBreakpoints.push(breakpoint);
            }
        }
        return specialBreakpoints;
    }

    const changeHandler = (id, value) => {
        if (id === 'testpatternfulllist') {
            testPatternChange(value, false);
        } else if (id === 'bl') {
            let newBLField = {...BLField};
            newBLField.value = value;
            setBLField(newBLField)
            changedBLField = newBLField;
        } else if (id === 'esbl') {
            let newESBLField = {...ESBLField};
            newESBLField.value = value;
            setESBLField(newESBLField)
            changedESBLField = newESBLField;
        } else if (id === 'carbapenemase') {
            let newCarbapenemaseField = {...CarbapenemaseField};
            newCarbapenemaseField.value = value;
            setCarbapenemaseField(newCarbapenemaseField)
            changedCarbapenemaseField = newCarbapenemaseField;
        } else if (id === 'deleteblankrows') {
            let newDeleteBlankRows = {...deleteBlankRows};
            newDeleteBlankRows.value = value;
            setDeleteBlankRows(newDeleteBlankRows);
            changedDeleteBlankRows = newDeleteBlankRows;
        } else if (id === 'astcommentone') {
            let newASTCommentOne = {...ASTCommentOne};
            newASTCommentOne.value = value;
            setASTCommentOne(newASTCommentOne)
            changedASTCommentOne = newASTCommentOne;
        } else if (id === 'astcommenttwo') {
            let newASTCommentTwo = {...ASTCommentTwo};
            newASTCommentTwo.value = value;
            setASTCommentTwo(newASTCommentTwo)
            changedASTCommentTwo = newASTCommentTwo;
        } else if (id === 'astadditionalnotes') {
            let newASTAdditionalNotes = {...ASTAdditionalNotes};
            newASTAdditionalNotes.value = value;
            setASTAdditionalNotes(newASTAdditionalNotes)
            changedASTAdditionalNotes = newASTAdditionalNotes;
        } else if (id === 'testpattern') {
            testPatternChange(value, true);
        } else {
            updateAntibioticsForm(id, value);
        }
        updateSaveableData();
    }

    const updateSaveableData = () => {

        let localTestPatternFullList = changedTestPatternFullList === null ? testPatternFullList : changedTestPatternFullList;
        let localBLField = changedBLField === null ? BLField : changedBLField;
        let localESBLField = changedESBLField === null ? ESBLField : changedESBLField;
        let localCarbapenemaseField = changedCarbapenemaseField === null ? CarbapenemaseField : changedCarbapenemaseField;
        let localDeleteBlankRows = changedDeleteBlankRows == null ? deleteBlankRows : changedDeleteBlankRows;
        let localASTCommentOne = changedASTCommentOne === null ? ASTCommentOne : changedASTCommentOne;
        let localASTCommentTwo = changedASTCommentTwo === null ? ASTCommentTwo : changedASTCommentTwo;
        let localASTAdditionalNotes = changedASTAdditionalNotes === null ? ASTAdditionalNotes : changedASTAdditionalNotes;
        let localTestPattern = changedTestPattern === null ? testPattern : changedTestPattern;
        let localDiskManualAntibioticsForm = changedDiskManualAntibioticsForm  === null ? [...diskManualAntibioticsForm] : [...changedDiskManualAntibioticsForm];
        let localStripManualAntibioticsForm = changedStripManualAntibioticsForm === null ? [...stripManualAntibioticsForm] : [...changedStripManualAntibioticsForm];

        let dataToSave = {
            testPatternFullList: localTestPatternFullList.value,
            BL: localBLField.value,
            ESBL: localESBLField.value,
            Carbapenemase: localCarbapenemaseField.value,
            deleteBlankRows: localDeleteBlankRows.value,
            ASTCommentOne: localASTCommentOne.value,
            ASTCommentTwo: localASTCommentTwo.value,
            ASTAdditionalNotes: localASTAdditionalNotes.value,
            testPattern: localTestPattern.value,
            ASTResults: []
        };

        let ASTResult = null;
        for (var row of localDiskManualAntibioticsForm) {
            if (row.antibiotic.value !== undefined && row.antibiotic.value !=="" && row.antibiotic.value !==null) {
                ASTResult = { TestType: 'Disk',
                              TestMethod: '681',
                              EntryType: 'manual',
                              Antibiotic: row.antibiotic.value,
                              Dosage: row.dosage.value === "" ? "0" : row.dosage.value,
                              Guidelines: row.guidelines.value,
                              Measurement: row.zoneDiameter.value === "" ? -1 : row.zoneDiameter.value, // -1 signals no value entered.
                              Susceptibility: row.susceptibility.value,
                              Category: row.category.value,
                              IncludeInReport: row.includeInReport.value,
                              AppliedBreakpointId: row.breakpointId,
                              SpecialRows: null
                            };

                if (row.specialRows !== undefined && row.specialRows.length > 0) {
                    var rowsToInclude = [];
                    for (var item of row.specialRows) {
                        var rowToInclude = {
                            Name: item.name,
                            SpecialTypeId: item.specialTypeId,
                            Susceptibility: item.susceptibility.value,
                            IncludeInReport: item.includeInReport.value
                        }
                        rowsToInclude.push(rowToInclude);
                    }
                    ASTResult.SpecialRows = rowsToInclude;
                } else {
                    ASTResult.SpecialRows = null;
                }

                dataToSave.ASTResults.push(ASTResult);
            }
        }

        for (row of localStripManualAntibioticsForm) {
            if (row.antibiotic.value !== undefined && row.antibiotic.value !=="" && row.antibiotic.value !==null) {
                ASTResult = { TestType: 'Strip',
                              TestMethod: '680',
                              EntryType: 'manual',
                              Antibiotic: row.antibiotic.value,
                              Dosage: "0", // row.dosage.value,
                              Guidelines: row.guidelines.value,
                              Measurement: row.MIC.value === "" ? -1 : row.MIC.value, // -1 signals no value entered.
                              Susceptibility: row.susceptibility.value,
                              Category: row.category.value,
                              IncludeInReport: row.includeInReport.value,
                              AppliedBreakpointId: row.breakpointId,
                              SpecialRows: null
                            };

                if (row.specialRows !== undefined && row.specialRows.length > 0) {
                    var rowsToInclude = [];
                    for (var item of row.specialRows) {
                        var rowToInclude = {
                            Name: item.name,
                            SpecialTypeId: item.specialTypeId,
                            Susceptibility: item.susceptibility.value,
                            IncludeInReport: item.includeInReport.value
                        }
                        rowsToInclude.push(rowToInclude);
                    }
                    ASTResult.SpecialRows = rowsToInclude;
                } else {
                    ASTResult.SpecialRows = null;
                }

                dataToSave.ASTResults.push(ASTResult);
            }
        }

        const changes = { Key: "ast", value: dataToSave };
        props.changeHandler('ast', changes);
    }

    const setSusceptibility = (row, type, antibioticIndex, value) => {

        let number = Number(value.toString().replace("<=","").replace(">","").replace("<",""));
        if (value === undefined || value === null || value === "" || number === 0) {
            row.susceptibility.value = "";
            if (row.specialRows !== undefined && row.SpecialRows !== null) {
                for (var specialRow of row.specialRows) {
                    specialRow.susceptibility.value = "";
                }
            }
            return "";
        }

        if (type === "Strip" && !value.toString().includes("<") && !value.toString().includes(">")) {

            // If entered MIC value matches a number in the MIC sequence for the guidelines used, skip the rounding up stage.
            var roundUp = true;
            if (row.guidelines.value === "971") {
                for (var mapping of MICValueMappingsForGuidelines) {
                    if (mapping.CLSI === Number(value)) {
                        roundUp = false;
                        break;
                    }
                }
            } else if (row.guidelines.value === "972") {
                for (var mapping of MICValueMappingsForGuidelines) {
                    if (mapping.EUCAST === Number(value)) {
                        roundUp = false;
                        break;
                    }
                }
            }

            // If not already matching a guideline approved value, attempt to round the entered value up to the next in the true geometric sequence (unless already in the sequence).
            if (roundUp) {
                var numericValue = Number(value);
                var sequence = 1;
                if (numericValue > 1) {
                    do {
                        sequence *= 2;
                    }
                    while (sequence < numericValue);
                    value = sequence;
                }
                else if (numericValue < 1) {
                    do {
                        sequence /= 2;
                    }
                    while (sequence > numericValue);
                    value = numericValue === sequence ? value : (sequence * 2); //.toFixed(3);
                }
            }

            // Map true geometric sequence value to equivalent in guideline sequence.
            if (row.guidelines.value === "971") {
                for (var mapping of MICValueMappingsForGuidelines) {
                    if (mapping.Geometric === Number(value)) {
                        value = mapping.CLSI;
                        break;
                    }
                }
            } else if (row.guidelines.value === "972") {
                for (var mapping of MICValueMappingsForGuidelines) {
                    if (mapping.Geometric === Number(value)) {
                        value = mapping.EUCAST;
                        break;
                    }
                }
            }
        }

        let newValue = value.toString().replace("<=","").replace(">","").replace("<","");
        let measurement = parseFloat(newValue);
        if (value.toString().substring(0,2) !== "<=") {
            if (value.toString().substring(0,1) === ">") {
                measurement = measurement + .001;
            }
            if (value.toString().substring(0,1) === "<") {
                measurement = measurement - .001;
            }
        }

        if (row.breakpoint !== undefined && row.breakpoint !== null && row.breakpoint.length > 0) {
            for (var breakpoint of row.breakpoint) {
                if (measurement >= breakpoint.StartVal && measurement <= breakpoint.EndVal) {
                    row.susceptibility.value = breakpoint.ResultId.toString();
                    break;
                } else {
                    row.susceptibility.value = "";
                }
            }
        }

        if (row.specialRows === undefined || row.specialRows === null) { return value.toString() }
        for (var breakpoint of row.specialBreakpoints) {
            var index = row.specialRows.findIndex(s => s.specialTypeId === breakpoint.SpecialConsiderId);
            if (index !== -1) {
                var breakpointLines = breakpoint.BreakpointGrid;
                for (var breakpointLine of breakpointLines) {
                    if (measurement >= breakpointLine.StartVal && measurement <= breakpointLine.EndVal) {
                        row.specialRows[index].susceptibility.value = breakpointLine.ResultId.toString();
                        break;
                    } else {
                        row.specialRows[index].susceptibility.value = "";
                    }
                }
            }
        }
        return value.toString()
    }

    const updateBreakpoints = (type, antibioticIndex, row) => {
        row.susceptibility.value = "";
        if (row.specialRows !== undefined && row.specialRows.length > 0) {
            for (var specialRow of row.specialRows) {
                specialRow.susceptibility.value = "";
            }
        }
        runBreakpointsQuery(cultureId,
                            row.antibiotic.value,
                            type === 'Disk' ? '681' : '680',
                            row.dosage.value,
                            row.guidelines.value,
                            row.handle,
                            breakpointsRetrieved,
                            errorWhenRetrievingData);
    }

    const breakpointsRetrieved = (data) => {
        let newDiskManualAntibioticsForm = [...diskManualAntibioticsForm];
        var index = 0;
        for (var row of newDiskManualAntibioticsForm) {
            if (row.handle === parseInt(data.Handle)) {
                row.breakpoint = getStandardBreakpoint(data.Breakpoints);
                row.specialBreakpoints = getSpecialBreakpoints(data.Breakpoints);
                addSpecialBreakpointRows(row, 'disk', index, row.includeInReport.value);
                setSusceptibility(row, 'Disk', index, row.zoneDiameter.value);
                setDiskManualAntibioticsForm(newDiskManualAntibioticsForm);
                changedDiskManualAntibioticsForm = [...newDiskManualAntibioticsForm];
            }
            index++;
        }
        let newStripManualAntibioticsForm = [...stripManualAntibioticsForm];
        var index = 0;
        for (var row of newStripManualAntibioticsForm) {
            if (row.handle === parseInt(data.Handle)) {
                row.breakpoint = getStandardBreakpoint(data.Breakpoints);
                row.specialBreakpoints = getSpecialBreakpoints(data.Breakpoints);
                addSpecialBreakpointRows(row, 'strip', index, row.includeInReport.value);
                setSusceptibility(row, 'Strip', index, row.MIC.value);
                setStripManualAntibioticsForm(newStripManualAntibioticsForm);
                changedStripManualAntibioticsForm = [...newStripManualAntibioticsForm];
            }
            index++;
        }
        updateSaveableData();
    }

    const updateAntibioticsForm = (id, value) => {
        let newDiskManualAntibioticsForm = [...diskManualAntibioticsForm];
        var index = 0;
        for (var row of newDiskManualAntibioticsForm) {
            let updated = false;
            if (id === row.antibiotic.Id) {
                if (value !== row.antibiotic.value && antibioticAlreadyInUse('Disk', value)) {
                    row.antibiotic.value = ""; updated = true;
                } else {
                    row.antibiotic.value = value; updated = true;
                }
                updateBreakpoints('Disk', index, row);
            } else if (id === row.dosage.Id && value !== row.dosage.value) {
                var getBreakpoints = (row.dosage.value !== value.toString());
                row.dosage.value = value; updated = true;
            if (getBreakpoints) { updateBreakpoints('Disk', index, row); }
            } else if (id === row.guidelines.Id && value !== row.guidelines.value) {
                row.guidelines.value = value; updated = true;
                updateBreakpoints('Disk', index, row);
                row.zoneDiameter.value = "";
            } else if (id === row.zoneDiameter.Id) {
                var numericValue = parseInt(value);
                if (value === row.zoneDiameter.value) {
                    updated = false;
                } else if (numericValue < row.zoneDiameter.min || numericValue > row.zoneDiameter.max || value === "") {
                    row.zoneDiameter.value = "";
                    value = "";
                    updated = true;
                } else {
                    row.zoneDiameter.value = value; updated = true;
                }
                if (updated) {
                    setSusceptibility(row, 'Disk', index, value);
                }
            } else if (id === row.susceptibility.Id) {
                row.susceptibility.value = value; updated = true;
            } else if (id === row.includeInReport.Id) {
                row.includeInReport.value = value; updated = true;
            }

            if (row.specialRows !== undefined && row.specialRows.length > 0) {
                for (var specialRow of row.specialRows) {
                    if (id === specialRow.susceptibility.Id) {
                        specialRow.susceptibility.value = value; updated = true;
                    } else if (id === specialRow.includeInReport.Id) {
                        specialRow.includeInReport.value = value; updated = true;
                    }
                }
            }

            if (updated) {
                setDiskManualAntibioticsForm(newDiskManualAntibioticsForm);
                changedDiskManualAntibioticsForm = [...newDiskManualAntibioticsForm];
                return;
            }
            index++;
        }
        let newStripManualAntibioticsForm = [...stripManualAntibioticsForm];
        index = 0;
        for (row of newStripManualAntibioticsForm) {
            let updated = false;
            if (id === row.antibiotic.Id) {
                if (value !== row.antibiotic.value && antibioticAlreadyInUse('Strip', value)) {
                    row.antibiotic.value = ""; updated = true;
                } else {
                    row.antibiotic.value = value; updated = true;
                }
                updateBreakpoints('Strip', index, row);
            } else if (id === row.dosage.Id && value !== row.dosage.value) {
                row.dosage.value = value; updated = true;
                updateBreakpoints('Strip', index, row);

            } else if (id === row.guidelines.Id && value !== row.guidelines.value) {
                row.guidelines.value = value; updated = true;
                updateBreakpoints('Strip', index, row);
                row.MIC.value = "";
            } else if (id === row.MIC.Id) {
                var numericValue = Number(value);
                if (row.MIC.value === value) {
                    updated = false;
                } else if (numericValue <= 0) {
//                    row.MIC.value = "";
//                    value = "";
                    updated = true;
                } else if (value !== row.MIC.value) {
//                    row.MIC.value = value;
                    updated = true;
                }
                if (updated) {
                    row.MIC.value = setSusceptibility(row, 'Strip', index, value);
                }
            } else if (id === row.susceptibility.Id) {
                row.susceptibility.value = value; updated = true;
            } else if (id === row.includeInReport.Id) {
                row.includeInReport.value = value; updated = true;
            }

            if (row.specialRows !== undefined && row.specialRows.length > 0) {
                for (var specialRow of row.specialRows) {
                    if (id === specialRow.susceptibility.Id) {
                        specialRow.susceptibility.value = value; updated = true;
                    } else if (id === specialRow.includeInReport.Id) {
                        specialRow.includeInReport.value = value; updated = true;
                    }
                }
            }

            if (updated) {
                setStripManualAntibioticsForm(newStripManualAntibioticsForm);
                changedStripManualAntibioticsForm = [...newStripManualAntibioticsForm];
                return;
            }
            index++;
        }
    }

    const antibioticAlreadyInUse = (type, antibioticId) => {

        if (type === 'Disk') {
            for (var row of diskManualAntibioticsForm) {
                if (row.antibiotic.value === antibioticId) {
                    return true;
                }
            }
            return false;
        }
        if (type === 'Strip') {
            for (var row of stripManualAntibioticsForm) {
                if (row.antibiotic.value === antibioticId) {
                    return true;
                }
            }
            return false;
        }
        return false;
    }

    const testPatternChange = (newValue, matched) => {
        runTestPatternQuery(cultureId, newValue, testPatternRetrieved, errorWhenRetrievingData);

        if (matched) {
            var newTestPatternConfig = testPattern;
            newTestPatternConfig.value = newValue;
            setTestPattern(newTestPatternConfig);

            // Null selection from full list control if matched pattern selected.
            let newTestPatternFullList = {...testPatternFullList};
            newTestPatternFullList.value = "";
            setTestPatternFullList(newTestPatternFullList)
            changedTestPatternFullList = newTestPatternFullList;
        } else {
            let newTestPatternFullList = {...testPatternFullList};
            newTestPatternFullList.value = newValue;
            setTestPatternFullList(newTestPatternFullList)
            changedTestPatternFullList = newTestPatternFullList;

            // Null selection from matched list control if pattern selected from full list.
            var newTestPatternConfig = testPattern;
            newTestPatternConfig.value = "";
            setTestPattern(newTestPatternConfig);
        }
    }

    const clearAllRows = () => {

        changedDiskManualAntibioticsForm = [];
        changedStripManualAntibioticsForm = [];
    }

    const testPatternRetrieved = (data) => {

        clearAllRows();

        // Start with an empty line for each test-method.
        addAntibioticClickHandler('Disk');
        addAntibioticClickHandler('Strip');

        if (data !== undefined && data !== null && data.AntibioticGrid !== undefined) {
            applyTestPattern(data.AntibioticGrid);
        }

        setDiskManualAntibioticsForm(changedDiskManualAntibioticsForm);
        setStripManualAntibioticsForm(changedStripManualAntibioticsForm);
    }

    const errorWhenRetrievingData = (errorMessage) => {
        console.log('Failed to retrieve data from backend with error:', errorMessage);
    }

    const addAntibioticClickHandler = (type) => {
        if (type === 'Disk') {
            let newDiskManualAntibioticsForm = changedDiskManualAntibioticsForm === null ? [...diskManualAntibioticsForm] : [...changedDiskManualAntibioticsForm];
            let newDiskManualRowCounter = changedDiskManualRowCounter === null ? diskManualRowCounter : changedDiskManualRowCounter;
            let newEntry =
            {
                handle: Math.floor(Math.random() * 100000),
                category: { Id: 'category' + newDiskManualRowCounter.toString(), Type: '', Label: '', value: '', Options: [], Resettable: true, noTab: true },
                antibiotic: { Id: 'diskmanuanti' + newDiskManualRowCounter.toString(), Type: 'combobox', Label: '', value: '', Options: [], Resettable: true, noTab: true },
                dosage: { Id: 'diskmanudose' + newDiskManualRowCounter.toString(), Type: 'number', Label: '', value: '', Min: '0', Max: '999', MaxDPs: '0', TabIndex: -1 },
                guidelines: { Id: 'diskmanuguide' + newDiskManualRowCounter.toString(), Type: 'dropdown', Label: '', value: '', Options: [], Resettable: true, noTab: true },
                zoneDiameter: { Id: 'diskmanumeas' + newDiskManualRowCounter.toString(), Type: 'number', Label: '', value: '', Min: '6', Max: '50', MaxDPs: '0' },
                susceptibility: { Id: 'diskmanususc' + newDiskManualRowCounter.toString(), Type: 'combobox', Label: '', value: '', Options: [], Resettable: true, noTab: true },
                includeInReport: { Id: 'diskmanuincl' + newDiskManualRowCounter.toString(), Type: 'toggle', Label: '', value: 'No', TabIndex: -1 }
            };

            let index = props.lists.findIndex(l => l.Name === 'drugcategory');
            if (index !== -1) {
                var unsorted = [];
                for (var option of props.lists[index].Options) {
                    let mappedOption = { key: option.Key, text: option.Text };
                    unsorted.push(mappedOption);
                }
                newEntry.category.Options = unsorted.sort((a, b) => { return a.key - b.key; });
            }

            index = props.lists.findIndex(l => l.Name === 'antibiotic');
            if (index !== -1) {
                for (var option of props.lists[index].Options) {
                    let mappedOption = { key: option.Key, text: option.Text };
                    newEntry.antibiotic.Options.push(mappedOption);
                }
            }

            index = props.lists.findIndex(l => l.Name === 'guidelines');
            if (index !== -1) {
                for (var option of props.lists[index].Options) {
                    let mappedOption = { key: option.Key, text: option.Text };
                    newEntry.guidelines.Options.push(mappedOption);
                }
            }

            index = props.lists.findIndex(l => l.Name === 'testresult');
            if (index !== -1) {
                for (option of props.lists[index].Options) {
                    let mappedOption = { key: option.Key, text: option.Text };
                    newEntry.susceptibility.Options.push(mappedOption);
                }
            }
            newDiskManualAntibioticsForm.push(newEntry);
            setDiskManualAntibioticsForm(newDiskManualAntibioticsForm);
            changedDiskManualAntibioticsForm = [...newDiskManualAntibioticsForm];
            setDiskManualRowCounter(newDiskManualRowCounter + 1);
            changedDiskManualRowCounter = newDiskManualRowCounter + 1;

        } else if (type === 'Strip') {
            let newStripManualAntibioticsForm = changedStripManualAntibioticsForm === null ? [...stripManualAntibioticsForm] : [...changedStripManualAntibioticsForm];
            let newStripManualRowCounter = changedStripManualRowCounter === null ? stripManualRowCounter : changedStripManualRowCounter;
            let newEntry =
            {
                handle: Math.floor(Math.random() * 100000),
                category: { Id: 'category' + newStripManualRowCounter.toString(), Type: '', Label: '', value: '', Options: [], Resettable: true, noTab: true },
                antibiotic: { Id: 'strpmanuanti' + newStripManualRowCounter.toString(), Type: 'combobox', Label: '', value: '', Options: [], Resettable: true, noTab: true },
                dosage: { Id: 'stripmanudose' + newStripManualRowCounter.toString(), Type: 'number', Label: '', value: '', Min: '0', Max: '999', MaxDPs: '0', TabIndex: -1 },
                guidelines: { Id: 'stripmanuguide' + newStripManualRowCounter.toString(), Type: 'dropdown', Label: '', value: '', Options: [], Resettable: true, noTab: true },
                MIC: { Id: 'strpmanumeas' + newStripManualRowCounter.toString(), Type: 'micdosage', Label: '', value: '', Min: '0', Max: '9999', MaxDPs: '3' },
                susceptibility: { Id: 'strpmanususc' + newStripManualRowCounter.toString(), Type: 'combobox', Label: '', value: '', Options: [], Resettable: true, noTab: true },
                includeInReport: { Id: 'strpmanuincl' + newStripManualRowCounter.toString(), Type: 'toggle', Label: '', value: 'No', TabIndex: -1 }
            }

            let index = props.lists.findIndex(l => l.Name === 'drugcategory');
            if (index !== -1) {
                for (var option of props.lists[index].Options) {
                    let mappedOption = { key: option.Key, text: option.Text };
                    newEntry.category.Options.push(mappedOption);
                }
            }

            index = props.lists.findIndex(l => l.Name === 'antibiotic');
            if (index !== -1) {
                for (option of props.lists[index].Options) {
                    let mappedOption = { key: option.Key, text: option.Text };
                    newEntry.antibiotic.Options.push(mappedOption);
                }
            }

            index = props.lists.findIndex(l => l.Name === 'guidelines');
            if (index !== -1) {
                for (var option of props.lists[index].Options) {
                    let mappedOption = { key: option.Key, text: option.Text };
                    newEntry.guidelines.Options.push(mappedOption);
                }
            }

            index = props.lists.findIndex(l => l.Name === 'testresult');
            if (index !== -1) {
                for (option of props.lists[index].Options) {
                    let mappedOption = { key: option.Key, text: option.Text };
                    newEntry.susceptibility.Options.push(mappedOption);
                }
            }
            newStripManualAntibioticsForm.push(newEntry);
            setStripManualAntibioticsForm(newStripManualAntibioticsForm);
            changedStripManualAntibioticsForm = [...newStripManualAntibioticsForm];
            setStripManualRowCounter(newStripManualRowCounter + 1);
            changedStripManualRowCounter = newStripManualRowCounter + 1;
        }
    }

    const removeAntibioticClickHandler = (type, index) => {
        if (type === 'Disk') {
            let newDiskManualAntibioticsForm = [...diskManualAntibioticsForm];
            newDiskManualAntibioticsForm.splice(index, 1);
            setDiskManualAntibioticsForm(newDiskManualAntibioticsForm);
            changedDiskManualAntibioticsForm = [...newDiskManualAntibioticsForm];
        } else if (type === 'Strip') {
            let newStripManualAntibioticsForm = [...stripManualAntibioticsForm];
            newStripManualAntibioticsForm.splice(index, 1);
            setStripManualAntibioticsForm(newStripManualAntibioticsForm);
            changedStripManualAntibioticsForm = [...newStripManualAntibioticsForm];
        }
        updateSaveableData();
    }

    const addSpecialBreakpointRows = (row, methodType, counter, printonreport) => {
        row.specialRows = [];
        if (row.specialBreakpoints.length === 0) { return }

        for (var breakpoint of row.specialBreakpoints) {
            let specialType = breakpoint.SpecialConsiderId;
            let name = "";
            let index = props.lists.findIndex(l => l.Name === 'specialconsiderations');
            if (index !== -1) {
                for (var option of props.lists[index].Options) {
                    if (option.Key === specialType.toString()) {
                        name = option.Text;
                        break;
                    }
                }
            }

            let newEntry =
            {
                name: name + ':',
                specialTypeId: breakpoint.SpecialConsiderId,
                susceptibility: { Id: methodType + 'susc' + counter.toString() + specialType.toString(), Type: 'combobox', Label: '', value: '', Options: [], Resettable: true, noTab: true },
                includeInReport: { Id: methodType + 'incl' + counter.toString() + specialType.toString(), Type: 'toggle', Label: '', value: printonreport, TabIndex: -1 }
            };

            index = props.lists.findIndex(l => l.Name === 'testresult');
            if (index !== -1) {
                for (option of props.lists[index].Options) {
                    let mappedOption = { key: option.Key, text: option.Text };
                    newEntry.susceptibility.Options.push(mappedOption);
                }
            }
            
            row.specialRows.push(newEntry);
        }
    };

    const restoreSpecialBreakpointRows = (row, specialRows, methodType, counter) => {
        if (specialRows === null || specialRows === undefined) { return }

        row.specialRows = [];
        for (var specialRow of specialRows) {
            let newEntry =
            {
                name: specialRow.Name,
                specialTypeId: specialRow.SpecialTypeId,
                susceptibility: { Id: methodType + 'susc' + counter.toString() + specialRow.SpecialTypeId.toString(), Type: 'combobox', Label: '', value: specialRow.Susceptibility, Options: [], Resettable: true, noTab: true },
                includeInReport: { Id: methodType + 'incl' + counter.toString() + specialRow.SpecialTypeId.toString(), Type: 'toggle', Label: '', value: specialRow.IncludeInReport, TabIndex: -1 }
            };

            var index = props.lists.findIndex(l => l.Name === 'testresult');
            if (index !== -1) {
                for (var option of props.lists[index].Options) {
                    let mappedOption = { key: option.Key, text: option.Text };
                    newEntry.susceptibility.Options.push(mappedOption);
                }
            }

            row.specialRows.push(newEntry);
        }
    }

    const removeSpecialBreakpointRow = (type, index, specialIndex) => {
        if (type === 'Disk') {
            let newDiskManualAntibioticsForm = [...diskManualAntibioticsForm];
            newDiskManualAntibioticsForm[index].specialRows.splice(specialIndex, 1);
            newDiskManualAntibioticsForm[index].specialBreakpoints.splice(specialIndex, 1);
            setDiskManualAntibioticsForm(newDiskManualAntibioticsForm);
            changedDiskManualAntibioticsForm = [...newDiskManualAntibioticsForm];
        } else if (type === 'Strip') {
            let newStripManualAntibioticsForm = [...stripManualAntibioticsForm];
            newStripManualAntibioticsForm[index].specialRows.splice(specialIndex, 1);
            newStripManualAntibioticsForm[index].specialBreakpoints.splice(specialIndex, 1);
            setStripManualAntibioticsForm(newStripManualAntibioticsForm);
            changedStripManualAntibioticsForm = [...newStripManualAntibioticsForm];
        }
        updateSaveableData();
    }

    const setShowDialog = data => {
        showDialogRef.current = data;
        _setShowDialog(data);
    };

    const deleteRow = () => {
        setShowDialog(false);

        if (rowToDelete.special === false) {
            removeAntibioticClickHandler(rowToDelete.type, rowToDelete.index);
        } else {
            removeSpecialBreakpointRow(rowToDelete.type, rowToDelete.index, rowToDelete.specialIndex);
        }
    }

    const dontDeleteRow = () => {
        setShowDialog(false);
    }

    const removeAntibioticConfirmation = (special, type, index, specialIndex) => {
        if (ASTRowRemovalConfirmation) {
            setRowToDelete({ special: special, type: type, index: index, specialIndex: specialIndex });
            setShowDialog(true);
        } else {
            if (special === false) {
                removeAntibioticClickHandler(type, index);
            } else {
                removeSpecialBreakpointRow(type, index, specialIndex);
            }
        }
    }

    const alertDataRetrievedSuccessfully = (data) => {
        setAlertMessages(data);
    }

    const resetAlerts = (culture_id) => {
        const criteria = { Parameters: [{ Key: 'id', Value: culture_id }, { Key: 'view', Value: "cultures" }] };
        Post('alert/get', criteria, alertDataRetrievedSuccessfully, errorWhenRetrievingData);
    }


    const globalFields = (
        <div>
            <div className='astform-subtitle'>
                {TranslateTag("@AstTesD@", props.language)}:
            </div>
            <div className='astform-first-row'>
                <div className='astform-antibiotic-level'>
                </div>
                {(testPattern !== null) ? (
                    <div>
                        <div>
                            <SingleLineField
                                key={testPattern.Id}
                                config={testPattern}
                                changeHandler={changeHandler}
                            >
                            </SingleLineField>
                        </div>
                    </div>
                ) : null }

                {(testPatternFullList !== null) ? (
                    <div>
                        <div>
                            <SingleLineField
                                key={testPatternFullList.Id}
                                config={testPatternFullList}
                                changeHandler={changeHandler}
                            >
                            </SingleLineField>
                        </div>
                    </div>
                ) : null }
            </div>
        </div>
    );

    const enzymeFields = (
        <div>
            <div className='astform-subtitle'>
                {TranslateTag("@AstEnz@", props.language)}:
            </div>
            <div className='astform-first-row'>
                <div className='astform-antibiotic-level'>
                </div>
                {(BLField !== null) ? (
                    <SingleLineField
                        key={BLField.Id}
                        config={BLField}
                        changeHandler={changeHandler}
                    >
                    </SingleLineField>
                ) : null }
                {(ESBLField !== null) ? (
                    <SingleLineField
                        key={ESBLField.Id}
                        config={ESBLField}
                        changeHandler={changeHandler}
                    >
                    </SingleLineField>
                ) : null }
                {(CarbapenemaseField !== null) ? (
                    <SingleLineField
                        key={CarbapenemaseField.Id}
                        config={CarbapenemaseField}
                        changeHandler={changeHandler}
                    >
                    </SingleLineField>
                ) : null }
            </div>
        </div>
    );

    const diskTests = (
        <div>
            <div className='astform-subtitle'>
                {TranslateTag("@AstDis@", props.language)}:
            </div>

            <div className='astform-manual-section'>
                {diskManualAntibioticsForm.length > 0 ? (
                    <div className='astform-test-pattern-title-bar'>
                        <div className='astform-antibiotic-level'>
                        </div>
                        <div className='astform-manual-title-antibiotic'>
                            {TranslateTag("@GenAnt@", props.language)}
                        </div>
                        <div className='astform-manual-title-dosage'>
                            {TranslateTag("@GenDos@", props.language)}&nbsp;(ug)
                        </div>
                        <div className='astform-manual-title-guidelines'>
                            {TranslateTag("@TesGui@", props.language)}
                        </div>
                        <div className='astform-manual-title-zone-diameter'>
                            {TranslateTag("@ZonDia@", props.language)}&nbsp;(mm)
                        </div>
                        <div className='astform-manual-title-susceptibility'>
                            {TranslateTag("@GenSus@", props.language)}
                        </div>
                        <div className='astform-manual-title-include-in-report'>
                            {TranslateTag("@GenInc@", props.language)}?
                        </div>
                    </div>
                ) : null }
                {diskManualAntibioticsForm.map((entry, index) => {
                    return (
                        <div key={index}>
                            <div key={index} className='astform-test-pattern-row'>
                                <div className='astform-antibiotic-level'>
                                    <TooltipHost
                                        content={entry.category.Options[entry.category.value > 1219 ? entry.category.value - 1220 : 0].text}
                                        id={100}
                                    >
                                        {/* <IconButton
                                            tabIndex={-1}
                                            iconProps={{iconName: 'MultiSelect'}}
                                            styles={{
                                                root: { color: entry.category.value > 1219 ? categoryColours[entry.category.value - 1220] : 'black' },
                                                iconHovered: { color: entry.category.value > 1219 ? categoryColours[entry.category.value - 1220] : 'black' }
                                            }}
                                        /> */}
                                        <div className={ 'astform-antibiotic-level-item-' + ((entry.category.value > 1219) ? categoryColours[entry.category.value - 1220] : 'white') }>
                                            <div>
                                                { entry.category.value > 1219 ? entry.category.value - 1219 : "" }
                                            </div>
                                        </div>
                                    </TooltipHost>
                                </div>
                                <div className='astform-manual-drug'>
                                    <SingleLineField
                                        key={entry.antibiotic.Id}
                                        config={entry.antibiotic}
                                        changeHandler={changeHandler}
                                    >
                                    </SingleLineField>
                                </div>
                                <div className='astform-manual-dosage'>
                                    <SingleLineField
                                        key={entry.dosage.Id}
                                        config={entry.dosage}
                                        changeHandler={changeHandler}
                                    >
                                    </SingleLineField>
                                </div>
                                <div className='astform-manual-guidelines'>
                                    <SingleLineField
                                        key={entry.guidelines.Id}
                                        config={entry.guidelines}
                                        changeHandler={changeHandler}
                                    >
                                    </SingleLineField>
                                </div>
                                <div className='astform-manual-zone-diameter'>
                                    <SingleLineField
                                        key={entry.zoneDiameter.Id}
                                        config={entry.zoneDiameter}
                                        changeHandler={changeHandler}
                                    >
                                    </SingleLineField>
                                </div>
                                <div className='astform-manual-susceptibility'>
                                    <SingleLineField
                                        key={entry.susceptibility.Id}
                                        config={entry.susceptibility}
                                        changeHandler={changeHandler}
                                        >
                                    </SingleLineField>
                                </div>
                                <div className='astform-manual-include-in-report'>
                                    <div className='astform-toggle'>
                                        <SingleLineField
                                            key={entry.includeInReport.Id}
                                            config={entry.includeInReport}
                                            changeHandler={changeHandler}
                                        >
                                        </SingleLineField>
                                    </div>
                                </div>
                                <div>
                                    <IconButton
                                        tabIndex={-1}
                                        iconProps={{iconName: 'Cancel'}}
                                        onClick={() => {removeAntibioticConfirmation(false, 'Disk', index)}}
                                    />
                                </div>
                            </div>
                            {entry.specialRows !== undefined && entry.specialRows.map((row, specialIndex) => {
                                return (

                                    <div className='astform-special-consider-row'>
                                        <div className='astform-special-consider-padding'>
                                        </div>
                                        <div className='astform-manual-label-special-consider'>
                                            {row.name}
                                        </div>
                                        <div className='astform-manual-susceptibility'>
                                            <SingleLineField
                                                key={row.susceptibility.Id}
                                                config={row.susceptibility}
                                                changeHandler={changeHandler}
                                                >
                                            </SingleLineField>
                                        </div>
                                        <div className='astform-manual-include-in-report'>
                                            <div className='astform-toggle'>
                                                <SingleLineField
                                                    key={row.includeInReport.Id}
                                                    config={row.includeInReport}
                                                    changeHandler={changeHandler}
                                                >
                                                </SingleLineField>
                                            </div>
                                        </div>
                                        <div>
                                            <IconButton
                                                tabIndex={-1}
                                                iconProps={{iconName: 'Cancel'}}
                                                onClick={() => {removeAntibioticConfirmation(true, 'Disk', index, specialIndex)}}
                                            />
                                        </div>
                                    </div>
                                )
                            })}

                        </div>
                    )
                })}
                <div className='astform-buttons'>
                    <div className='astform-antibiotic-level'>
                    </div>
                    <PrimaryButton
                        tabIndex={-1}
                        text={TranslateTag("@TesAddD@", props.language)}
                        onClick={() => {addAntibioticClickHandler('Disk')}}
                    />
                </div>
            </div>
        </div>
    );

    const stripTests = (
        <div>
            <div className='astform-subtitle'>
                {TranslateTag("@AstMic@", props.language)}:
            </div>

            <div className='astform-manual-section'>
                {stripManualAntibioticsForm.length > 0 ? (
                    <div className='astform-test-pattern-title-bar'>
                        <div className='astform-antibiotic-level'>
                        </div>
                        <div className='astform-manual-title-antibiotic'>
                            {TranslateTag("@GenAnt@", props.language)}
                        </div>
                        <div className='astform-manual-title-dosage'>
                        </div>
                        <div className='astform-manual-title-guidelines'>
                            {TranslateTag("@TesGui@", props.language)}
                        </div>
                        <div className='astform-test-pattern-title'>
                            {TranslateTag("@AstMicA@", props.language)}&nbsp;(ug/mL)
                        </div>
                        <div className='astform-manual-title-susceptibility'>
                            {TranslateTag("@GenSus@", props.language)}
                        </div>
                        <div className='astform-manual-title-include-in-report'>
                            {TranslateTag("@GenInc@", props.language)}?
                        </div>
                    </div>
                ) : null }
                {stripManualAntibioticsForm.map((entry, index) => {
                    return (
                        <div key={index}>
                            <div key={index} className='astform-test-pattern-row'>
                                <div className='astform-antibiotic-level'>
                                    <TooltipHost
                                        content={entry.category.Options[entry.category.value > 1219 ? entry.category.value - 1220 : 0].text}
                                        id={100}
                                    >
                                        {/* <IconButton
                                            tabIndex={-1}
                                            iconProps={{iconName: 'MultiSelect'}}
                                            styles={{
                                                root: { color: entry.category.value > 1219 ? categoryColours[entry.category.value - 1220] : 'black' },
                                                iconHovered: { color: entry.category.value > 1219 ? categoryColours[entry.category.value - 1220] : 'black' }
                                            }}
                                        /> */}
                                        <div className={ 'astform-antibiotic-level-item-' + ((entry.category.value > 1219) ? categoryColours[entry.category.value - 1220] : 'white') }>
                                            <div>
                                                { entry.category.value > 1219 ? entry.category.value - 1219 : "" }
                                            </div>
                                        </div>
                                    </TooltipHost>
                                </div>
                                <div className='astform-manual-drug'>
                                    <SingleLineField
                                        key={entry.antibiotic.id}
                                        config={entry.antibiotic}
                                        changeHandler={changeHandler}
                                    >
                                    </SingleLineField>
                                </div>
                                <div className='astform-manual-dosage hidden'>
                                    <SingleLineField
                                        key={entry.dosage.Id}
                                        config={entry.dosage}
                                        changeHandler={changeHandler}
                                    >
                                    </SingleLineField>
                                </div>
                                <div className='astform-manual-guidelines'>
                                    <SingleLineField
                                        key={entry.guidelines.Id}
                                        config={entry.guidelines}
                                        changeHandler={changeHandler}
                                    >
                                    </SingleLineField>
                                </div>
                                <div className='astform-test-pattern-row-item'>
                                    <SingleLineField
                                        key={entry.MIC.id}
                                        config={entry.MIC}
                                        changeHandler={changeHandler}
                                    >
                                    </SingleLineField>
                                </div>
                                <div className='astform-manual-susceptibility'>
                                    <SingleLineField
                                        key={entry.susceptibility.id}
                                        config={entry.susceptibility}
                                        changeHandler={changeHandler}
                                    >
                                    </SingleLineField>
                                </div>
                                <div className='astform-manual-include-in-report'>
                                    <div className='astform-toggle'>
                                        <SingleLineField
                                            key={entry.includeInReport.id}
                                            config={entry.includeInReport}
                                            changeHandler={changeHandler}
                                        >
                                        </SingleLineField>
                                    </div>
                                </div>
                                <div>
                                    <IconButton
                                        tabIndex={-1}
                                        iconProps={{iconName: 'Cancel'}}
                                        onClick={() => {removeAntibioticConfirmation(false, 'Strip', index)}}
                                    />
                                </div>
                            </div>
                            {entry.specialRows !== undefined && entry.specialRows.map((row, specialIndex) => {
                                return (

                                    <div className='astform-special-consider-row'>
                                        <div className='astform-special-consider-padding'>
                                        </div>
                                        <div className='astform-manual-label-special-consider'>
                                            {row.name}
                                        </div>
                                        <div className='astform-manual-susceptibility'>
                                            <SingleLineField
                                                key={row.susceptibility.Id}
                                                config={row.susceptibility}
                                                changeHandler={changeHandler}
                                                >
                                            </SingleLineField>
                                        </div>
                                        <div className='astform-manual-include-in-report'>
                                            <div className='astform-toggle'>
                                                <SingleLineField
                                                    key={row.includeInReport.Id}
                                                    config={row.includeInReport}
                                                    changeHandler={changeHandler}
                                                >
                                                </SingleLineField>
                                            </div>
                                        </div>
                                        <div>
                                            <IconButton
                                                tabIndex={-1}
                                                iconProps={{iconName: 'Cancel'}}
                                                onClick={() => {removeAntibioticConfirmation(true, 'Strip', index, specialIndex)}}
                                            />
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    )
                })}
                <div className='astform-buttons'>
                    <div className='astform-antibiotic-level'>
                    </div>
                    <PrimaryButton
                        tabIndex={-1}
                        text={TranslateTag("@TesAddD@", props.language)}
                        onClick={() => {addAntibioticClickHandler('Strip')}}
                    />
                </div>
            </div>
        </div>
    );

    const comments = ( 
        <div>
            <div>
                <div className='astform-subtitle'>
                    Comments:
                    {/* {TranslateTag("@AstTesD@", props.language)}: */}
                </div>
                <div className='astform-first-row'>
                    <div className='astform-antibiotic-level'>
                    </div>
                    <div className='astform-comments'>
                        {ASTCommentOne !== null ? (
                            <SingleLineField
                                key={ASTCommentOne.Id}
                                config={ASTCommentOne}
                                changeHandler={changeHandler}
                            >
                            </SingleLineField>
                        ) : null }
                    </div>
                </div>
                <div className='astform-first-row'>
                    <div className='astform-antibiotic-level'>
                    </div>
                    <div className='astform-comments'>
                        {ASTCommentTwo !== null ? (
                            <SingleLineField
                                key={ASTCommentTwo.Id}
                                config={ASTCommentTwo}
                                changeHandler={changeHandler}
                            >
                            </SingleLineField>
                        ) : null }
                    </div>
                </div>
            </div>
            <div className='astform-first-row'>
                {/* <br /> */}
                <div className='astform-antibiotic-level'>
                </div>
                <div className='astform-comments'>
                    {ASTAdditionalNotes !== null ? (
                        <SingleLineField
                            key={ASTAdditionalNotes.Id}
                            config={ASTAdditionalNotesConfig}
                            changeHandler={changeHandler}
                        >
                        </SingleLineField>
                    ) : null }
                </div>
            </div>
        </div>
    );

    const deleteLinesControl = ( 
        <div className='astform-above-save'>
            {(deleteBlankRows !== null) ? (
            <SingleLineField
                key={deleteBlankRows.Id}
                config={deleteBlankRows}
                changeHandler={changeHandler}
            >
            </SingleLineField>
            ) : null }
        </div>
    );

    const rowRemovalConfirmation = (
        <div>
            <Dialog
                hidden={!showDialog}
                dialogContentProps={dialogContentProps}
                modalProps={modalPropsStyles}
            >
                <DialogFooter>
                    <PrimaryButton onClick={deleteRow} text={TranslateTag("@GenYesA@", props.language)} />
                    <DefaultButton onClick={dontDeleteRow} text={TranslateTag("@GenNo@", props.language)} />
                </DialogFooter>
            </Dialog>
        </div>
    );


    return (
        <div className='astform-content'>
            <div className='astform-title'>
                {props.config.PageTitle}
            </div>
            <div className='astform-headertext'>
                {props.config.Text}
            </div>
            <br />
            <AlertList messages={alertMessages} position="top"></AlertList>
            {globalFields}
            {diskTests}
            {stripTests}
            {enzymeFields}
            {comments}
            <br />
            {rowRemovalConfirmation}
            {deleteLinesControl}
            <AlertList messages={alertMessages} position="bottom"></AlertList>
        </div>
    )
};


const mapStateToProps = state => {
    return {
        lists: state.config.lists,
        preferences: state.config.preferences
    };
}

export default connect(mapStateToProps)(AST);
